/* eslint-disable jsx-a11y/label-has-for */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable import/no-named-as-default-member */
import React, { Component } from 'react'
import CreatableSelect from 'react-select/lib/Creatable'
import _ from 'lodash'
import { Form } from 'semantic-ui-react'

class SearchKeywordsField extends Component {
  onChange = selectedOptions => {
    const { onChange } = this.props

    const result = selectedOptions.map(({value}) =>  _.lowerCase(value))

    onChange(result)
  }

  serializeValues = values => {
    return _.map(values, (value) => ({
      value,
      label: value,
    }))
  }

  render() {
    const { value } = this.props
    return (
      <Form.Field>
        <label>Search Keywords</label>
        <CreatableSelect
          isMulti
          value={this.serializeValues(value)}
          onChange={this.onChange}
          // onCreateOption={this.onCreateOption}
        />
      </Form.Field>
    )
  }
}

export default SearchKeywordsField



// WEBPACK FOOTER //
// ./src/components/restaurants/fields/searchKeywordsField.js